import { Toast as BaseToast } from '@base-ui/react/toast'

import { Button } from '#components/button'
import { IconCrossMedium } from '#components/icon/IconCrossMedium'

export function ToastDismissButton() {
  return (
    <BaseToast.Close
      render={
        <Button
          aria-label="Dismiss"
          leftSection={<IconCrossMedium />}
          size="small"
          variant="ghost"
        />
      }
    />
  )
}
ToastDismissButton.displayName = 'Toast.DismissButton'
